import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Str from "shared/components/Str";
import MessageDropdown from "features/messagedropdown";
import MessagesIcon from "shared/components/svgs/Messages.svg";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

const MessagesButton = ({ isSelected }) => {
	useEffect(() => {
		// Need to do this here because when the MessageDropdown feature gets
		// initialized, the Button hasn't been rendered yet. When the React NavBar
		// app goes out to 100% of users, the MessageDropdown.init call in the
		// OnDOMReady in features/messagedropdown/index.js can be removed in favor
		// of this line.
		MessageDropdown.init();
	}, []);

	return (
		<div
			id="nav_mailbox"
			className="navbar-link navbar-message"
		>
			{/**
				The button has no onClick button because legacy
				MessagesDropdown adds click listeners based on the
				nav_mailbox id.
			*/}
			<button
				className="navbar-message-btn"
				onClick={() => {
					selectedOptionOnNavBarEvent("Conversations Dropdown");
				}}
			>
				<div className="navbar-message-btn-container">
					<div className="navbar-link-icon-container" >
						<MessagesIcon
							className={classnames("navbar-icon", {
								"navbar-icon-selected": isSelected,
							})}
							width={24}
							height={24}
						/>
						<div
							className={classnames("navbar-underline", {
								"navbar-underline-selected": isSelected,
							})}
						/>
						{/**
							 * Mailbox inbox count is jQuery-ed in via InstantEvents.
							 * Need id="navbar-mailbox" so that the count
							 * can be injected into the dom.
						*/}
						<div id="navbar-mailbox" />
					</div>
					<span className="navbar-text">
						<Str>Messages</Str>
					</span>
				</div>
			</button>
		</div>
	);
};

MessagesButton.defaultProps = {
	isSelected: false,
};

MessagesButton.propTypes = {
	isSelected: PropTypes.bool,
};

export default MessagesButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/MessagesButton.jsx